import { ReactNode } from 'react';
import { ProjectJsonData } from 'src/types/project';

import { ImportConfigurationContext } from './import-configuration-context';
import { useImportConfigurationController } from './use-import-configuration-controller';

export { IMPORT_CONFIGURATION_STEPS } from './import-configuration-steps';

interface ImportConfigurationProviderProps {
  children: ReactNode;
  onApplyImport: (data: ProjectJsonData) => void;
}

export const ImportConfigurationProvider = ({
  children,
  onApplyImport,
}: ImportConfigurationProviderProps) => {
  const contextValue = useImportConfigurationController(onApplyImport);

  return (
    <ImportConfigurationContext.Provider value={contextValue}>
      {children}
    </ImportConfigurationContext.Provider>
  );
};
